@if (loadingAssets()) {
  <ui-skeleton-table />
} @else {
  @if (isHeader()) {
    <form
      [formGroup]="filtersForm"
      class="flex items-center justify-between border-gray-200 pb-4 text-sm"
      [ngClass]="{ 'border-gray-200': assetType() !== 'REPORT' && assetType() !== 'REPORTTEMPLATE' }"
    >
      <!-- Left: Search and Date Filters -->
      <div class="flex items-center">
        <!-- Search Input -->
        <div
          class="flex items-center w-[400px] bg-white border border-gray-300 rounded-lg px-3 py-1.5 mr-4 shadow-sm focus-within:ring-2 focus-within:ring-offset-1 focus-within:ring-blue-500 focus-within:border-blue-500"
        >
          <img src="assets/icons/search.svg" alt="Search" class="h-5 w-5 mr-2 shrink-0" />
          <input
            formControlName="criteria"
            type="text"
            placeholder="Search by name..."
            class="w-full focus:outline-none bg-transparent placeholder-gray-500 text-sm py-1"
          />
        </div>
      </div>

      <!-- Right: Action Icons & Date Filters -->
      <div class="flex items-center space-x-1">
        <button type="button" (click)="refreshAssetsTrigger()" class="p-2 rounded-full text-gray-600 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500">
          <ui-icon name="reload" class="stroke-2 stroke-gray-600 size-6"></ui-icon>
        </button>

        @if (assetType() == 'REPORTTEMPLATE' || assetType() == 'REPORT') {
          <button type="button" (click)="onChangeListType(listType())" class="p-2 rounded-full text-gray-600 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500">
            @if (listType() == 'list') {
              <ui-icon name="category" class="stroke-2 stroke-gray-600 size-6"></ui-icon>
            } @else if (listType() == 'category') {
              <ui-icon name="list" class="stroke-2 stroke-gray-600 size-6"></ui-icon>
            }
          </button>
          <button type="button" class="p-2 rounded-full text-gray-600 hover:text-gray-800 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500">
            <ui-icon name="gear" class="stroke-2 stroke-gray-600 size-6"></ui-icon>
          </button>
        }

        <!-- Date Filters -->
        @if (!hideDateFilter()) {
          <div class="inline-flex rounded-md shadow-sm ml-4" role="group">
            <button
              type="button"
              (click)="onFilterClick('all')"
              [ngClass]="{
                'bg-gray-100 text-gray-800 border-gray-300 z-10 ring-1 ring-gray-300': selectedDateFilter() === 'all',
                'bg-white text-gray-700 border-gray-300 hover:bg-gray-50': selectedDateFilter() !== 'all'
              }"
              class="relative inline-flex items-center px-4 py-2 text-sm font-medium rounded-l-md border focus:z-20 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              All
            </button>
            <button
              type="button"
              (click)="onFilterClick('30')"
              [ngClass]="{
                'bg-gray-100 text-gray-800 border-gray-300 z-10 ring-1 ring-gray-300': selectedDateFilter() === '30',
                'bg-white text-gray-700 border-gray-300 hover:bg-gray-50': selectedDateFilter() !== '30'
              }"
              class="relative inline-flex items-center px-4 py-2 text-sm font-medium border-t border-b -ml-px border-gray-300 focus:z-20 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              Last 30 days
            </button>
            <button
              type="button"
              (click)="onFilterClick('90')"
              [ngClass]="{
                'bg-gray-100 text-gray-800 border-gray-300 z-10 ring-1 ring-gray-300': selectedDateFilter() === '90',
                'bg-white text-gray-700 border-gray-300 hover:bg-gray-50': selectedDateFilter() !== '90'
              }"
              class="relative inline-flex items-center px-4 py-2 text-sm font-medium rounded-r-md border -ml-px border-gray-300 focus:z-20 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              Last 90 days
            </button>
          </div>
        }
      </div>
    </form>
  }

  <div class="border border-gray-200 rounded-lg overflow-hidden shadow-sm">
    @if (!assets().length) {
      <div class="flex flex-col items-center py-14">
        <div class="mb-4 w-44">
          <img src="assets/img/clouds.svg" alt="" class="w-full h-auto" />
        </div>
        <p class="text-xl font-bold mb-2">Soo much empty!</p>
        <p class="mb-8 text-center">Seems you have no assets here.</p>
      </div>
    } @else {
      <div [ngStyle]="{'height': calculateHeight(assetHeight())}" class="custom-height-asset-data" (scroll)="handleScroll($event)">

        @if (assetType() !== 'REPORTTEMPLATE' && assetType() !== 'REPORT') {
          <div [ngStyle]="{'height': calculateHeight(assetHeight())}" class="custom-scroll-container custom-height-asset-data" (scroll)="handleScroll($event)">
            <ng-container *ngTemplateOutlet="tableContent"></ng-container>
          </div>
        }

        @if (assetType() === 'REPORTTEMPLATE' || assetType() === 'REPORT') {
          @if (listType() === 'list') {
            <div class="custom-scroll-container custom-height-asset-data overflow-y-auto">
              <ng-container *ngTemplateOutlet="tableContent"></ng-container>
            </div>
          } @else {
            <div>
              <ng-container *ngTemplateOutlet="categoryContent"></ng-container>
            </div>
          }
        }

        <ng-template #tableContent>
          <table class="w-full text-sm border-collapse">
            <thead>
              <tr>
                @if (showSelectionCheckbox()) {
                  <th scope="col" class="pl-4 py-3 w-10">
                    <!-- No "Select All" checkbox as per requirements -->
                  </th>
                }
                @for (header of tableHeaders(); track header) {
                  <th class="text-left py-4 px-4 border-b-2 border-gray-200 font-bold bg-gray-50 uppercase text-gray-600">
                    {{ header.text }}
                  </th>
                }
              </tr>
            </thead>
            <tbody class="pl-2 text-base">
              @for (asset of assets(); track asset) {
                <tr
                  (click)="openReportTemplateAssetModal($event, asset)"
                  class="h-14 rounded-md hover:bg-gray-50 cursor-pointer transition-colors duration-150 ease-in-out border-b border-gray-100 group/row"
                  [ngClass]="{'disabled-asset-row': isAssetDisabled(asset.id)}"
                >
                  @if (showSelectionCheckbox()) {
                    <td class="pl-4 py-4 whitespace-nowrap">
                      <div class="flex items-center">
                        <input
                          [type]="singleSelectionMode() ? 'radio' : 'checkbox'"
                          [name]="singleSelectionMode() ? 'assetSelection' : ''"
                          [checked]="isItemSelected(asset.id)"
                          [disabled]="isAssetDisabled(asset.id)"
                          (click)="$event.stopPropagation(); toggleItemSelection(asset, $event)"
                          class="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                          [ngClass]="{'rounded': !singleSelectionMode(), 'rounded-full': singleSelectionMode()}"
                        />
                      </div>
                    </td>
                  }

                  <td class="py-3 px-4 align-middle">
                    @if (newScope()) {
                      <p class="cursor-pointer group-hover/row:text-blue-600" (click)="assetNameClicked(asset)">
                        {{ asset.name }}
                      </p>
                    } @else {
                      <span (click)="onAssetNameClick(asset)" class="cursor-pointer group-hover/row:text-blue-600">
                        {{ asset.name }}
                      </span>
                    }
                  </td>

                  @if (assetType() !== 'CONVERSATION') {
                    <td class="py-3 px-4 align-middle">
                      {{ asset.description | slice : 0 : 70 }}@if (asset.description?.length > 70) {<span>...</span>}
                    </td>
                  }

                  @if (assetType() !== 'REPORT' && assetType() !== 'REPORTTEMPLATE') {
                    <td class="py-3 px-4 align-middle">
                      {{ asset.updatedAt | date : "medium" }}
                    </td>
                  }

                  @if (assetType() == 'REPORT' || assetType() == 'REPORTTEMPLATE') {
                    <td class="py-3 px-4 align-middle">
                      @if (asset.tags.length > 0) {
                        @for (tag of asset.tags.slice(0, 2); track tag; let i = $index) {
                          @if (i === 0) {
                            <span class="font-medium px-2.5 py-1 text-[#175CD3] me-2 bg-[#EFF8FF] rounded-full">
                              {{ tag }}
                            </span>
                          }
                          @if (i === 1) {
                            <span class="font-medium px-2.5 py-1 text-[#3F5DFF] me-2 bg-[#F5F7FF] rounded-full">
                              {{ tag }}
                            </span>
                          }
                        }
                        @if (asset.tags.length > 2) {
                          <span class="font-medium px-2.5 py-1 text-gray-600 me-2 bg-gray-100 rounded-full">
                            +{{ asset.tags.length - 2 }}
                          </span>
                        }
                      }
                    </td>
                  }

                  @if (assetType() == 'DATASCOPE') {
                    <td class="py-3 px-4 align-middle cursor-pointer" (click)="onConnectionClick(asset.parameters.CONNECTIONS[0])">
                      {{ asset.parameters.CONNECTIONS[0].name }}
                    </td>
                  }

                  @if (assetType() == 'CONNECTION') {
                    <td class="py-3 px-4 align-middle">
                      <span class="inline-flex items-center px-2.5 py-1 text-xs font-bold rounded-full me-2 border-2">
                        @if (asset.parameters.DATASOURCE) {
                          <img
                            [src]="getDatabaseLogoSrc(asset.parameters.DATASOURCE)"
                            alt="{{ asset.parameters.DATASOURCE }} logo"
                            class="mr-2 w-8 h-6"
                          />
                        }
                        {{ asset.type.toUpperCase() }}
                      </span>
                    </td>
                  }

                  @if (isControls()) {
                    <td class="py-3 px-4 align-middle">
                      <div class="flex items-center justify-end space-x-4">

                        @if (assetType() === 'CONNECTION') {
                          <a [routerLink]="singleAssetRouterLink()" [queryParams]="{ id: asset.id }">
                            <div class="relative inline-block group mt-2">
                              <ui-icon name="eye" size="size-6" class="stroke-gray-700 hover:stroke-blue-700"></ui-icon>
                              <div class="absolute hidden bg-gray-800 text-white text-xs rounded-lg p-2 w-42 bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap group-hover:block z-10">
                                Connection Details
                              </div>
                            </div>
                          </a>
                          <div class="relative inline-block group">
                            <a routerLink="/dashboard/data-catalog" [queryParams]="{ id: asset.id }" class="cursor-pointer">
                              <img src="assets/icons/book.svg" alt="Data Catalog" />
                            </a>
                            <div class="absolute hidden bg-gray-800 text-white text-xs rounded-lg p-2 bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap group-hover:block z-10">
                              Data Catalog
                            </div>
                          </div>
                        }

                        @if (assetType() === 'DATASCOPE' || assetType() === 'QUESTIONS') {
                          <div class="relative inline-block group cursor-pointer" (click)="createReport(asset)">
                            <ui-icon name="reports" class="stroke-gray-700 hover:stroke-blue-700"></ui-icon>
                            <div class="absolute hidden bg-gray-800 text-white text-xs rounded-lg p-2 w-42 bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap group-hover:block z-10">
                              Reports
                            </div>
                          </div>
                        }

                        @if (assetType() === 'DATASCOPE' || assetType() === 'QUESTIONS') {
                          <div class="relative inline-block group cursor-pointer" (click)="navigateToCopilot(asset.id)">
                            <ui-icon name="data-copilot" class="stroke-gray-700 hover:stroke-blue-700"></ui-icon>
                            <div class="absolute hidden bg-gray-800 text-white text-xs rounded-lg p-2 w-42 bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap group-hover:block z-10">
                              Data Copilot
                            </div>
                          </div>
                        }

                        @if (assetType() === 'REPORTTEMPLATE') {
                          <div class="cursor-pointer">
                            <ui-icon name="eye" class="stroke-[#475467] hover:stroke-blue-700" size="size-6"></ui-icon>
                          </div>
                        }

                        @if (assetType() !== 'REPORTTEMPLATE' && !hideActionButtons()) {
                          <div class="flex items-center space-x-4">
                            <div class="relative inline-block group">
                              <span (click)="handleEditAction(asset); $event.stopPropagation()" class="cursor-pointer">
                                <ui-icon name="pencil" class="stroke-gray-700 hover:stroke-blue-700"></ui-icon>
                              </span>
                              <div class="absolute hidden bg-gray-800 text-white text-xs rounded-lg p-2 bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap group-hover:block z-10">
                                Edit
                              </div>
                            </div>
                            <div class="relative inline-block group">
                              <span (click)="openManageAssetModal(asset, 1); $event.stopPropagation()" class="cursor-pointer">
                                <ui-icon name="trash" class="stroke-gray-700 hover:stroke-red-700"></ui-icon>
                              </span>
                              <div class="absolute hidden bg-gray-800 text-white text-xs rounded-lg p-2 bottom-8 left-1/2 transform -translate-x-1/2 whitespace-nowrap group-hover:block z-10">
                                Delete
                              </div>
                            </div>
                          </div>
                        }

                      </div>
                    </td>
                  }
                </tr>
              } @empty {
                <tr class="py-16 text-center">
                  <td colspan="3" class="py-16 text-gray-500">
                    No results for:
                    <span class="font-bold text-lg text-gray-700">{{
                      searchTerm().length > 0 ? searchTerm() : controls["criteria"].value
                    }}</span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </ng-template>

        <ng-template #categoryContent>
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-4">
            @for (asset of assets(); track asset; let i = $index) {
              <div
                class="p-6 border rounded-xl border-gray-200 relative transition-all duration-200 ease-in-out group"
                [ngClass]="{
                  'cursor-pointer hover:border-blue-400 hover:shadow-lg': assetType() !== 'REPORTTEMPLATE' && !isAssetDisabled(asset.id),
                  'opacity-75': assetType() === 'REPORTTEMPLATE',
                  'disabled-asset-row': isAssetDisabled(asset.id)
                }"
                (click)="assetType() !== 'REPORTTEMPLATE' && !isAssetDisabled(asset.id) && onCategoryClick(asset)"
              >
                @if (assetType() === 'REPORTTEMPLATE') {
                  <div class="absolute top-3 right-3 px-2.5 py-1 bg-blue-500 text-white text-xs font-semibold rounded-full shadow-sm">
                    Coming Soon
                  </div>
                }

                <div class="flex justify-between items-start mb-3">
                  <div class="w-full">
                    @if (showSelectionCheckbox()) {
                      <div class="absolute top-2 right-2">
                        <input
                          [type]="singleSelectionMode() ? 'radio' : 'checkbox'"
                          [name]="singleSelectionMode() ? 'assetSelection' : ''"
                          [checked]="isItemSelected(asset.id)"
                          [disabled]="isAssetDisabled(asset.id)"
                          (click)="$event.stopPropagation(); toggleItemSelection(asset, $event)"
                          class="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                          [ngClass]="{'rounded': !singleSelectionMode(), 'rounded-full': singleSelectionMode()}"
                        />
                      </div>
                    }

                    <p class="text-gray-800 font-semibold text-lg mb-1 group-hover:text-blue-600">{{ asset.name }}</p>
                    <p class="text-gray-600 text-sm w-[90%]">
                      {{ asset.description | slice : 0 : 140 }}
                      @if (asset.description?.length > 140) {<span>...</span>}
                    </p>
                  </div>
                </div>

                <div class="my-4 flex justify-center items-center bg-gray-50 rounded-lg overflow-hidden aspect-video">
                  <img [src]="asset.src" alt="{{asset.name}} image" class="w-full h-full object-contain p-4" />
                </div>

                <div class="flex items-center justify-between">
                  <div class="flex flex-wrap gap-2">
                    @for (tag of asset.tags.slice(0, 3); track tag) {
                      <span class="px-3 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-full">{{ tag }}</span>
                    }
                    @if (asset.tags.length > 3) {
                      <span class="px-3 py-1 text-xs font-medium text-gray-600 bg-gray-100 rounded-full">
                        +{{ asset.tags.length - 3 }}
                      </span>
                    }
                  </div>
                  @if (assetType() == 'REPORTTEMPLATE') {
                    <ui-icon name="star" class="stroke-2 stroke-gray-400 group-hover:stroke-yellow-500 transition-colors"></ui-icon>
                  }
                </div>
              </div>
            }
          </div>
        </ng-template>

      </div>
    }
  </div>
}
